/**
 * Booking questions stamped onto the booking when specific add-ons are
 * purchased. Only affirmative answers are sent — an unselected add-on sends
 * nothing (no `false` entries).
 */
export const CONFETTI_QUESTION_ID = 829;
export const FIRST_TOAST_QUESTION_ID = 830;

export interface BookingQuestionAnswer {
  id: number;
  answer: boolean;
}

export function buildAddOnQuestionAnswers(selected: {
  confetti?: boolean;
  firstToast?: boolean;
}): BookingQuestionAnswer[] {
  const questions: BookingQuestionAnswer[] = [];
  if (selected.confetti) {
    questions.push({ id: CONFETTI_QUESTION_ID, answer: true });
  }
  if (selected.firstToast) {
    questions.push({ id: FIRST_TOAST_QUESTION_ID, answer: true });
  }
  return questions;
}
